import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import payonner from '../assets/logo-payoneer.png';
import upwork from '../assets/logo-upwork.png';
// import ln from '../assets/logo-ln.svg';

function footer() {
  return (
    <footer>
      <div className="footer__grid">
        <div className="footer__navigation footer__grid--nav">
          <h3 className="info__title">Shajar LLC</h3>
          <NavLink to="/aboutus">About us</NavLink>
          {'  ∙  '}
          <NavLink to="/services">Services</NavLink> {'  ∙  '}
          <NavLink to="/contact">Contact</NavLink>
          <br />
          <NavLink to="/termsandconditions">Terms & conditons</NavLink>
          {'  ∙  '}
          <NavLink to="/privacypolicy">Privacy policy</NavLink> {'  ∙  '}
        </div>
        <div className="info footer__grid--accept">
          <h4 className="info__title">We accept</h4>
          <img src={upwork} alt="upwork" />
          <img src={payonner} alt="payonner" />
        </div>
        <div>
          <div className="info footer__grid--contact">
            <h4 className="info__title">Contact us</h4>
            <a href="tel:+14782871368" target="_blank" rel="noreferrer">
              +1 478 287 1368
            </a>
            <br />
            <a
              href="mailto:contact@shajarthecompany.store"
              target="_blank"
              rel="noreferrer"
            >
              contact@shajarthecompany.store
            </a>
            <br />

            {/* </div> */}
            {/* <div className="info footer__grid--office"> */}
            {/* <h4 className="info__title"> Office</h4> */}
            <br />
            <br />
            <p>444 Alaska Avenue, Suite #BQN474, Torrance, CA 90503, USA</p>
          </div>
        </div>
        <h2 className="footer__title footer__grid--title">
          <Link to="/" className="logo">
            Shajar LLC
          </Link>
          <br />
          Let&apos;s work together!{' '}
        </h2>
      </div>
    </footer>
  );
}

export default footer;
